import { publicClient, privateClient } from './client';
import { Order } from './Order';

const transactionsOrder = (pub: boolean) => new Order(pub ? publicClient : privateClient);
export default transactionsOrder;
